const units = [
  'byte',
  'kilobyte',
  'megabyte',
  'gigabyte',
  'terabyte',
  'petabyte',
  'exabyte',
];

export const formatBytes = (
  bytes: number,
  locales?: Parameters<typeof Intl.NumberFormat>[0],
) => {
  const unit = bytes === 0 ? 0 : Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes === 0 ? 0 : bytes / Math.pow(1024, unit);

  // Intl.NumberFormat use a base 1000 but for bytes we need a base 1024
  return new Intl.NumberFormat(locales, {
    style: 'unit',
    unit: units[unit],
    unitDisplay: 'narrow',
  }).format(value);
};
